import React, { useState } from 'react';

/*
 * Shared "show prices" toggle logic. Each page keeps its own CSS untouched —
 * pass in the exact class names, icon markup and table shape already used on
 * that page's stylesheet so visual output is unchanged.
 */
function PriceAccordion({
  sectionClassName,
  containerClassName,
  wrapperClassName,
  barClassName,
  labelClosed,
  labelOpen,
  iconClassName,
  iconOpenClass,
  iconContent,
  bodyClassName,
  tableClassName,
  useThead = false,
  columns,
  rows,
  noteClassName,
  note,
}) {
  const [open, setOpen] = useState(false);
  const label = labelOpen ? (open ? labelOpen : labelClosed) : labelClosed;

  const headerRow = (
    <tr>
      {columns.map((c, i) => <th key={i}>{c}</th>)}
    </tr>
  );

  const body = (
    <>
      <button className={barClassName} onClick={() => setOpen(o => !o)} aria-expanded={open}>
        <span>{label}</span>
        <span className={`${iconClassName}${open ? ` ${iconOpenClass}` : ''}`}>{iconContent}</span>
      </button>
      {open && (
        <div className={bodyClassName}>
          <table className={tableClassName}>
            {useThead ? (
              <>
                <thead>{headerRow}</thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i}>{r.map((cell, j) => <td key={j}>{cell}</td>)}</tr>
                  ))}
                </tbody>
              </>
            ) : (
              <tbody>
                {headerRow}
                {rows.map((r, i) => (
                  <tr key={i}>{r.map((cell, j) => <td key={j}>{cell}</td>)}</tr>
                ))}
              </tbody>
            )}
          </table>
          {note && <p className={noteClassName}>{note}</p>}
        </div>
      )}
    </>
  );

  return (
    <section className={sectionClassName}>
      <div className={containerClassName}>
        {wrapperClassName ? <div className={wrapperClassName}>{body}</div> : body}
      </div>
    </section>
  );
}

export default PriceAccordion;
